import Vue from "vue";
import { ApiResponse } from "@/data/apiClient";

export interface Notification {
  title: string;
  subtitle?: string;
  content: string;
}

export function displayRequestStatus(
  resp: ApiResponse<unknown>,
  okMessage = "",
  errorMessage = "Request failed"
): ApiResponse<unknown> {
  if (resp.ok && okMessage) {
    Vue.$toast.success(okMessage);
  } else if (!resp.ok) {
    if (resp?.response?.data?.errorMessage && resp.response.status < 500) {
      Vue.$toast.error(String(resp.response.data.errorMessage || errorMessage));
    } else {
      Vue.$toast.error(errorMessage);
    }
  }
  return resp;
}

export async function requestWithNotification(
  func: Promise<ApiResponse<unknown>>,
  okMessage = "",
  errorMessage = "Request failed",
  okFunc?: (resp: ApiResponse<unknown>) => void,
  failFunc?: (resp: ApiResponse<unknown>) => void
): Promise<ApiResponse<unknown>> {
  const resp = displayRequestStatus(await func, okMessage, errorMessage);
  resp.ok ? okFunc && okFunc(resp) : failFunc && failFunc(resp);
  return resp;
}
